import { computed } from 'vue'
import { VALID_DROPDOWN_BUTTON_TYPES } from '../constants/dropdown-button-constants.js'

/**
 * Core logic for DropDown Button component
 */
export function useDropDownButton(props) {
  // State computations
  const isDisabled = computed(() => Boolean(props.disabled))
  
  // Content checks
  const hasText = computed(() => Boolean(props.text))
  const hasLeftIcon = computed(() => Boolean(props.leftIcon))
  const hasRightIcon = computed(() => Boolean(props.rightIcon))
  
  // Menu related
  const hasMenuItems = computed(() => Array.isArray(props.menuItems) && props.menuItems.length > 0)
  const effectiveMaxHeight = computed(() => props.maxHeight || null)
  
  // Validation
  const isValidType = computed(() => VALID_DROPDOWN_BUTTON_TYPES.includes(props.type))
  
  // Border states
  const shouldShowBorder = computed(() => Boolean(props.hasBorder))
  const shouldShowParentBorder = computed(() => Boolean(props.hasBorderParent))
  
  // Special states
  const isFooterHelpful = computed(() => Boolean(props.isBtnFooterHelpFul))
  const shouldShowMenu = computed(() => Boolean(props.hasShowMenu))
  
  // Custom positioning and sizing
  const hasCustomPosition = computed(() => Boolean(props.customPositionMenu))
  const customMenuWidth = computed(() => props.customWidth || 0)
  const menuHeightOffset = computed(() => props.heightOffset || 5)
  const menuWidthOffset = computed(() => props.widthOffset || 25)
  
  // Tooltip
  const hasTooltip = computed(() => Boolean(props.tooltipText))
  
  return {
    // State
    isDisabled,
    
    // Content
    hasText,
    hasLeftIcon,
    hasRightIcon,
    
    // Menu
    hasMenuItems,
    effectiveMaxHeight,
    
    // Validation
    isValidType,
    
    // Border
    shouldShowBorder,
    shouldShowParentBorder,
    
    // Special states
    isFooterHelpful,
    shouldShowMenu,
    
    // Positioning
    hasCustomPosition,
    customMenuWidth,
    menuHeightOffset,
    menuWidthOffset,
    
    // Tooltip
    hasTooltip
  }
}
